import * as ActionTypes from "./actionTypes";

export function updateFormErrors(errors) {
	return { type: ActionTypes.UPDATE_FORM_ERRORS, errors };
}
